import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { VideoDetails as VideoDetailsContainer } from '../containers/content/videos'
import { useRelatedVideos, useVideoById } from '../../hocs/content/useVideos'
import config from '../../config'
import Loading from '../components/layout/Loading'
import { useI18N } from '../../libraries/i18n/hook'
import { useCourseById } from '../../hocs/content/useCourses'
import * as coursesLib from '../../libraries/content/courses'

const Video = () => {
  const { id, courseId } = useParams()
  const { t } = useI18N()
  const navigate = useNavigate()

  if(!id) return <div>Invalid video id</div>
  const { data: relatedVideosData, isLoading: isRelatedVideosLoading, error: relatedVideosError } = useRelatedVideos(parseInt(id, 10), config.VITE_MAX_CAROUSEL_ITEMS)
  const { data: courseData, isLoading: isCourseLoading, error: courseError } = useCourseById(courseId ?? '')

  const nextVideoId = courseId && courseData
    ? coursesLib.getNextVideoId(courseData, id)
    : relatedVideosData?.[0]?.id
  const nextVideoIdStr = nextVideoId != null ? String(nextVideoId) : ''
  const { data: nextVideoData } = useVideoById(nextVideoIdStr)

  const redirectToNextVideo = () => {
    if(courseId && courseData) {
      const nextId = coursesLib.getNextVideoId(courseData, id)
      if(nextId != null) {
        navigate(`/courses/${courseId}/videos/${nextId}`)
      } else {
        // course finished navigate to course page
        navigate(`/courses/${courseId}`)
      }
    } else if(relatedVideosData?.length) {
      navigate(`/content/videos/${relatedVideosData[0].id}`)
    }
  }

  if(isRelatedVideosLoading || isCourseLoading) return <Loading />
  if(relatedVideosError || courseError) return <div>{t(`error.${courseError?.code ?? relatedVideosError?.code}`)}</div>

  const nextVideo = nextVideoId != null ? nextVideoData : undefined
  return <VideoDetailsContainer id={id} redirectToNextVideo={redirectToNextVideo} nextVideo={nextVideo} />
}

export default React.memo(Video)
